var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8704 2.55322H6.24429L0.132812 8.6647L10.5574 20.5996L20.9819 8.6647L14.8704 2.55322ZM8.61882 8.1898L10.5574 4.4217L12.4959 8.1898H8.61882ZM12.6828 9.12404L10.5262 16.8549L8.43197 9.12404H12.6828ZM7.46659 9.12404L9.50634 16.668L2.91996 9.12404H7.46659ZM13.6481 9.12404H18.1948L11.515 16.777L13.6481 9.12404ZM17.9768 8.1898H13.9128L14.4812 4.69419L17.9768 8.1898ZM13.5936 4.34385L13.1109 7.33341L11.5695 4.34385H13.5936ZM8.01156 7.33341L7.52887 4.34385H9.55305L8.01156 7.33341ZM6.63356 4.69419L7.20189 8.1898H3.13795L6.63356 4.69419Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.689 2.29667C20.6847 1.82177 19.8673 1.00431 19.3924 0C18.9175 1.00431 18.1078 1.81398 17.0957 2.29667C18.1 2.77158 18.9175 3.58903 19.3924 4.59334C19.8751 3.58125 20.6847 2.77158 21.689 2.29667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86152 18.3346C3.01292 17.9297 2.32781 17.2524 1.93076 16.4038C1.52592 17.2524 0.8486 17.9375 0 18.3346C0.8486 18.7394 1.53371 19.4167 1.93076 20.2653C2.3356 19.4167 3.01292 18.7394 3.86152 18.3346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4793 15.6722C18.9109 15.3998 18.4516 14.9482 18.1869 14.3799C17.9144 14.9482 17.4629 15.4075 16.8945 15.6722C17.4629 15.9447 17.9222 16.3963 18.1869 16.9646C18.4594 16.3963 18.9109 15.9447 19.4793 15.6722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRareWhite);
export default __webpack_public_path__ + "static/media/RareWhite.f16b8ee530714b5b78eafc77b2d92568.svg";
export { ForwardRef as ReactComponent };